import api from './ApiHandler';
export const getDropdownData = async () => {
  let res = await api.get('get-dropdown-data');
  return res;
};
